import { collection, doc } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { matchConverter } from './converters';

export const matchesCol = (tournamentId: string) =>
  collection(db, 'tournaments', tournamentId, 'matches').withConverter(matchConverter);

export const matchDoc = (tournamentId: string, matchId: string) =>
  doc(db, 'tournaments', tournamentId, 'matches', matchId).withConverter(matchConverter);
